import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as writeFromDictationServices from '@iso/services/listening/writeFromDictation';

//#region CRUD
export function* getWriteFromDictation() {
	yield takeLatest(actions.GET_WRITE_FROM_DICTATION, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(writeFromDictationServices.getWriteFromDictation, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_WRITE_FROM_DICTATION_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getWriteFromDictationDetail() {
	yield takeLatest(actions.GET_WRITE_FROM_DICTATION_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(writeFromDictationServices.getWriteFromDictationDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_WRITE_FROM_DICTATION_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesWriteFromDictation() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_WRITE_FROM_DICTATION, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(writeFromDictationServices.createQuesWriteFromDictation, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
			else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateWriteFromDictationDetail() {
	yield takeLatest(actions.UPDATE_WRITE_FROM_DICTATION_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(writeFromDictationServices.updateWriteFromDictationDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteWriteFromDictation() {
	yield takeLatest(actions.DELETE_WRITE_FROM_DICTATION, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(writeFromDictationServices.deleteWriteFromDictation, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getWriteFromDictation),
		fork(getWriteFromDictationDetail),
		fork(createQuesWriteFromDictation),
		fork(updateWriteFromDictationDetail),
		fork(deleteWriteFromDictation),
	]);
}
